"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushtextHref = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const pushtext_href_style_1 = __importDefault(require("./pushtext.href.style"));
class PushtextHref extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, children, href, mute, warning, disabled, external, textRef: ref, prefix, suffix } = this.props;
            if (disabled) {
                return (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.root, "data-is-disabled": "true" }, { children: [prefix && jsx_runtime_1.jsx("span", Object.assign({ className: classes.prefix }, { children: prefix }), void 0),
                        jsx_runtime_1.jsx("span", Object.assign({ className: classes.text }, { children: children }), void 0),
                        suffix && jsx_runtime_1.jsx("span", Object.assign({ className: classes.suffix }, { children: suffix }), void 0)] }), void 0));
            }
            const textProps = {
                href,
                role: 'button',
                className: classes.text,
                ref
            };
            if (external) {
                textProps.rel = 'external';
                textProps.target = '_blank';
            }
            return (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.root, "data-is-muted": mute, "data-is-warning": warning }, { children: [prefix && jsx_runtime_1.jsx("span", Object.assign({ className: classes.prefix }, { children: prefix }), void 0),
                    jsx_runtime_1.jsx("a", Object.assign({}, textProps, { children: children }), void 0),
                    suffix && jsx_runtime_1.jsx("span", Object.assign({ className: classes.suffix }, { children: suffix }), void 0)] }), void 0));
        };
    }
}
exports.PushtextHref = PushtextHref;
PushtextHref.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node.isRequired,
    href: prop_types_1.default.string.isRequired,
    textRef: prop_types_1.default.func,
    mute: prop_types_1.default.bool,
    warning: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool,
    external: prop_types_1.default.bool,
    prefix: prop_types_1.default.node,
    suffix: prop_types_1.default.node
};
PushtextHref.defaultProps = {
    textRef: null,
    mute: false,
    warning: false,
    disabled: false,
    external: false,
    prefix: null,
    suffix: null
};
exports.default = react_jss_1.default(pushtext_href_style_1.default)(PushtextHref);
//# sourceMappingURL=pushtext.href.js.map